__turbopack_context__.v({
  "button": "primary-module-scss-module__72ZxQW__button" + " " + __turbopack_context__.i(693367)["block"],
  "complete": "primary-module-scss-module__72ZxQW__complete" + " " + __turbopack_context__.i(693367)["complete"],
  "medium": "primary-module-scss-module__72ZxQW__medium" + " " + __turbopack_context__.i(693367)["medium"],
  "playing": "primary-module-scss-module__72ZxQW__playing" + " " + __turbopack_context__.i(693367)["playing"],
  "small": "primary-module-scss-module__72ZxQW__small" + " " + __turbopack_context__.i(693367)["small"],
});
